// extracted by mini-css-extract-plugin
export default {"footerLogo":"z4SW0","imageWrapper":"cxpVa","image":"CPNY_"};